import { formatExactTime, formatRelativeTime } from '@/shared/utils/time';
import type { RunLabel } from '../runLabel';

/**
 * A run named inline: "Implement · Completed · 2 hours ago" (spec 119
 * FR-005) — the step, the outcome in its usual colour, and when, with the
 * exact moment one hover away, exactly as the run's own group names it.
 */
export function RunLabelText({ label }: { label: RunLabel }) {
  return (
    <span className="inline-flex flex-wrap items-baseline gap-x-1">
      <span className="text-foreground">{label.name}</span>
      <span aria-hidden="true">·</span>
      <span className={label.outcome.colourClass}>{label.outcome.label}</span>
      {label.when ? (
        <>
          <span aria-hidden="true">·</span>
          <time dateTime={label.when} title={formatExactTime(label.when)}>
            {formatRelativeTime(label.when)}
          </time>
        </>
      ) : null}
    </span>
  );
}
